<script lang="ts">
  export let text: string;
</script>

<div class="avatar-wrapper">
  <span class="avatar-text">{text}</span>
</div>

<style lang="postcss">
  .avatar-wrapper {
    @apply relative inline-flex items-center justify-center w-10 h-8 overflow-hidden bg-gray-300 rounded-full;
  }
  .avatar-text {
    @apply font-medium text-white;
  }
</style>
